import {
  searchByName,
  getPage,
  getDetail,
  addObj,
  modifyObj,
  deleteObj,
  getUsersCount,
  getAllUsers,
  setRoles,
  changeUserState,
  resetPassword,
  disable,
} from '@/api/userserv'

export default {
  state: {
    state_User_SearchByNameResult: null,
    state_User_GetPageResult: null,
    state_User_GetDetailResult: null,
    state_User_AddObjResult: null,
    state_User_ModifyObjResult: null,
    state_User_DeleteObjResult: null,
    state_User_GetUsersCountResult: null,
    state_User_GetAllUsersResult: null,
    state_User_SetRolesResult: null,
    state_User_ChangeUserStateResult: null,
    state_User_ResetPasswordResult: null,
    state_User_DisableResult: null,
  },
  mutations: {
    SET_USER_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_User_SearchByNameResult = rst;
    },
    SET_USER_GETPAGE_RESULT: (state, rst) => {
      state.state_User_GetPageResult = rst;
    },
    SET_USER_GETDETAIL_RESULT: (state, rst) => {
      state.state_User_GetDetailResult = rst;
    },
    SET_USER_ADDOBJ_RESULT: (state, rst) => {
      state.state_User_AddObjResult = rst;
    },
    SET_USER_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_User_ModifyObjResult = rst;
    },
    SET_USER_DELETEOBJ_RESULT: (state, rst) => {
      state.state_User_DeleteObjResult = rst;
    },
    SET_USER_GETUSERSCOUNT_RESULT: (state, rst) => {
      state.state_User_GetUsersCountResult = rst;
    },
    SET_USER_GETALLUSERS_RESULT: (state, rst) => {
      state.state_User_GetAllUsersResult = rst;
    },
    SET_USER_SETROLES_RESULT: (state, rst) => {
      state.state_User_SetRolesResult = rst;
    },
    SET_USER_CHANGEUSERSTATE_RESULT: (state, rst) => {
      state.state_User_ChangeUserStateResult = rst;
    },
    SET_USER_RESETPASSWORD_RESULT: (state, rst) => {
      state.state_User_ResetPasswordResult = rst;
    },
    SET_USER_DISABLE_RESULT: (state, rst) => {
      state.state_User_DisableResult = rst;
    },
  },
  actions: {
    UserServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USER_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USER_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USER_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USER_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USER_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USER_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USER_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USER_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USER_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USER_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USER_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USER_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserServ_GetUsersCount({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getUsersCount(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USER_GETUSERSCOUNT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USER_GETUSERSCOUNT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserServ_GetAllUsers({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAllUsers(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USER_GETALLUSERS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USER_GETALLUSERS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserServ_SetRoles({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        setRoles(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USER_SETROLES_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USER_SETROLES_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserServ_ChangeUserState({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        changeUserState(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USER_CHANGEUSERSTATE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USER_CHANGEUSERSTATE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserServ_ResetPassword({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        resetPassword(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USER_RESETPASSWORD_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USER_RESETPASSWORD_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserServ_Disable({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        disable(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USER_DISABLE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USER_DISABLE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_User_SearchByNameResult: state => {
      return state.state_User_SearchByNameResult;
    },
    get_User_GetPageResult: state => {
      return state.state_User_GetPageResult;
    },
    get_User_GetDetailResult: state => {
      return state.state_User_GetDetailResult;
    },
    get_User_AddObjResult: state => {
      return state.state_User_AddObjResult;
    },
    get_User_ModifyObjResult: state => {
      return state.state_User_ModifyObjResult;
    },
    get_User_DeleteObjResult: state => {
      return state.state_User_DeleteObjResult;
    },
    get_User_GetUsersCountResult: state => {
      return state.state_User_GetUsersCountResult;
    },
    get_User_GetAllUsersResult: state => {
      return state.state_User_GetAllUsersResult;
    },
    get_User_SetRolesResult: state => {
      return state.state_User_SetRolesResult;
    },
    get_User_ChangeUserStateResult: state => {
      return state.state_User_ChangeUserStateResult;
    },
    get_User_ResetPasswordResult: state => {
      return state.state_User_ResetPasswordResult;
    },
    get_User_DisableResult: state => {
      return state.state_User_DisableResult;
    },
  }
}